import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import logo from './../../assets/myma_logo.png';
import TopnavEasyAccess from './Topnav.EasyAccess';
import Select from 'react-select';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  AxiosAPI,
  getGroupID,
  AxiosStripeAPI,
  getUserID,
  AxiosPublicAPI,
  AxiosStripeAPI_US,
  getUserRole,
} from '../../helpers/AxiosAPI';
import {
  gAPI_Subscription_By_Group_Id,
  gAPI_BotConversations_list,
  gAPI_AgentConversations_list,
  gAPI_Group_By_Id,
  gAPI_LinkedGrups_By_Id,
  gAPI_Users_LinkedProperties_By_Id,
  gAPI_Users_LinkedGrups_By_Id,
  putAPI_AgentStatus,
  putAPI_UpdateAgentStatus_By_Id,
  postApi_Billing_Details_US,
  postApi_Billing_Details,
  gAPI_Site_Settings,
} from '../../constants/APIs';
import { reactSelectProperties } from '../../helpers/Utils';
import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  changeProperty,
  getPropertyList,
  changeTimeZone,
  changeCurrency,
  changeGroupBillingCurrency,
  ConnectUser,
  SetAgent,
  BotBlink,
  AgentBlink,
  changeServiceProviderLogo,
  changeServiceProvider,
  fetchTwilioConversationsRequest,
} from '../../redux/actions';
import TwilioConversationApp from '../../views/app/pages/conversations/components/TwilioConversationApp';
import {
  menuHiddenBreakpoint,
  searchPath,
  localeOptions,
  themeColorStorageKey,
  isDarkSwitchActive,
} from '../../constants/defaultValues';
import timeZoneList from '../../data/timeZoneList';
import { MobileMenuIcon, MenuIcon } from '../../components/svg';
import { getDirection, setDirection } from '../../helpers/Utils';
// import Navbar from 'reactstrap/lib/Navbar';
// import ModalHeader from 'reactstrap/lib/ModalHeader';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import moment from 'moment';
import { BusinessProfile } from '../pages/BussinessProfile';
import Intercom from './Intercom';
import TopnavDarkSwitch from './Topnav.DarkSwitch';
import IntlMessages from '../../helpers/IntlMessages';
//import ColorSwitcher from '../../components/common/ColorSwitcher';

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
      searchKeyword: '',
      hotel: { value: '-1', label: 'All' },
      hotelName: 'All',
      stripeCustomerId: '',
      showTwilioConversationList: false,
      showBotConversationOn: false,
      showAgentConversation: false,
      botConversationList: [],
      agentConversationList: [],
      groupsList: [],
      linkedGroups: [],
      isAivaProperty: false,
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      type: '',
      groupName: '',
      NotificationTitle: '',
      showLinkedGroups: false,
      loading: false,
      chatInvitations: [],
      showAgentStatus: false,
      agentStatus: false,
      activationdate: '',
      bussinessProfileVisible: false,
      propertyList: this.props.plist,
      helpcenterUrl: '',
      isShowChat: false,
    };
    this.audio = new Audio(
      'https://bmbuiassetsprod.blob.core.windows.net/images/chat1.mp3'
    );
  }

  componentWillReceiveProps(props) {
    // if (props.signalRConnection.newConnection !== undefined) {
    //   console.log(
    //     'props.signalRConnection.newConnection.connection',
    //     props.signalRConnection.newConnection.connection._connectionState
    //   );
    // }
    if (
      props.signalRConnection.newConnection !== undefined &&
      this.props.signalRConnection.newConnection === undefined
    ) {
      const { intl } = props;
      const newMsgTitle = intl.formatMessage({ id: 'dashboard.new_chat_message' });
      const dismissText = intl.formatMessage({ id: 'content.dismiss' });
      const openText = intl.formatMessage({ id: 'content.open' });
      console.log('message', newMsgTitle, dismissText, openText)
      // props.signalRConnection.newConnection.connection.on(
      //   'newConnection',
      //   (m) => {
      console.log('****** newConnection ******');
      const user = this.props.userData;
      const userProperties = [];
      if (user.properties.length > 0) {
        if (user.properties[0] === '-1') {
          this.props.plist.forEach((p) => {
            userProperties.push(p.id);
          });
        } else {
          user.properties.forEach((p) => {
            userProperties.push(p);
          });
        }
      }

      //     AxiosPublicAPI({
      //       method: 'post',
      //       url: `${process.env.REACT_APP_SIGNALR}/api/AddToGroup`,
      //       data: {
      //         connectionId: m,
      //         recipient: getUserID(),
      //         groupname: userProperties,
      //       },
      //     }).then((resp) => {});
      //   }
      //);

      props.signalRConnection.newConnection.connection
        .invoke('SendMessage', {
          recipient: getUserID(),
          groupname: userProperties,
        })
        .catch(function (err) {
          console.error(err.toString());
        });

      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        (message) => {
          console.log(
            '****** newChatUserMessage ******',
            message,
            this.props.twilioConversationsReducer.twilioConversations
          );
          if (message.Source === 'Visitor') {
            const onAgentAssistPage =
              typeof window !== 'undefined' &&
              window.location &&
              window.location.pathname &&
              window.location.pathname.includes('pages/agent-assist');

            if (
              !onAgentAssistPage &&
              this.props.twilioConversationsReducer.twilioConversations &&
              this.props.twilioConversationsReducer.twilioConversations.length >
              0
            ) {
              const conversation =
                this.props.twilioConversationsReducer.twilioConversations.find(
                  (c) =>
                    c.channelState.uniqueName.includes(
                      message.BotConversationId
                    )
                );
              if (conversation && conversation !== undefined) {
                console.log('Found conversation:', conversation);
                // create a small, styled DOM popup at bottom-right showing the message text

                try {
                  // determine accent color from CSS var or stored theme (fallback)

                  // show styled chat popup (uses project accent)
                  if (!document.getElementById('myma-chat-popup-styles')) {
                    const style = document.createElement('style');
                    style.id = 'myma-chat-popup-styles';
                    style.innerHTML = `                      
                      @keyframes myma-popup-in { from { transform: translateY(12px) scale(.98); opacity: 0 } to { transform: translateY(0) scale(1); opacity: 1 } }
                      .myma-chat-popup-container { position: fixed; right: 20px; bottom: 20px; z-index: 2147483647; display:flex; flex-direction: column; gap: 12px; align-items: flex-end; pointer-events: none; }
                      .myma-chat-popup { pointer-events: auto; width: 340px; background: linear-gradient(180deg,#fff,#fbfdff); border-radius: 10px; border: 1px solid rgba(15,23,36,0.08); box-shadow: 0 10px 30px rgba(18,36,63,0.12); overflow: hidden; font-family: Inter, Roboto, "Helvetica Neue", Arial, sans-serif; color:#1f2937; animation: myma-popup-in .18s ease both; }
                      .myma-chat-popup .header { display:flex; align-items:center; gap:10px; padding:12px 12px 6px 12px; }
                      .myma-chat-popup .avatar { width:40px; height:40px; border-radius:8px; object-fit:cover; display:flex; align-items:center; justify-content:center; overflow:hidden; }
                      .myma-chat-popup .avatar img { width:100%; height:100%; object-fit:cover; display:block; }
                      .myma-chat-popup .title { font-weight:600; font-size:14px; line-height:1; color:#0f1724; }
                      .myma-chat-popup .meta { font-size:12px; color:#64748b; margin-top:4px; }
                      .myma-chat-popup .body { padding:6px 12px 12px 12px; font-size:13px; color:#0f1724; max-height:110px; overflow:auto; line-height:1.35; }
                      .myma-chat-popup .actions { display:flex; justify-content:flex-end; gap:8px; padding:8px 12px 12px 12px; }                      
                      .myma-chat-popup .close-x { position:absolute; right:8px; top:6px; background:transparent; border:0; font-size:16px; color:#94a3b8; cursor:pointer; }
                      @media (max-width:420px){ .myma-chat-popup{ width:calc(100% - 40px); right:10px; left:10px; } .myma-chat-popup-container{ right:10px; left:10px; align-items:center; } }
                    `;
                    document.head.appendChild(style);
                  }

                  // ensure container exists (stacks popups)
                  let container = document.getElementById(
                    'myma_chat_popup_container'
                  );
                  if (!container) {
                    container = document.createElement('div');
                    container.id = 'myma_chat_popup_container';
                    container.className = 'myma-chat-popup-container';
                    document.body.appendChild(container);
                  }

                  // derive message text safely
                  let contentMsg = '';
                  if (
                    message.Content &&
                    message.Content.type === 'messages' &&
                    message.Content.messages.length > 0
                  ) {
                    contentMsg = message.Content.messages[0];
                  }

                  const botMsg = contentMsg
                    ? String(contentMsg)
                    : 'New media message received';

                  const popupId = `myma_chat_popup_${conversation.channelState.uniqueName || Date.now()
                    }`;

                  // remove existing same-conversation popup
                  const existing = document.getElementById(popupId);
                  if (existing) existing.remove();

                  // prefer visitor/conversation avatar -> message avatar -> login profile -> fallback bot-off
                  let avatarSrc =
                    'https://bmbuiassetsprod.blob.core.windows.net/images/profile_pic.png';

                  const popup = document.createElement('div');
                  popup.id = popupId;
                  popup.className = 'myma-chat-popup';
                  popup.setAttribute('role', 'dialog');
                  popup.setAttribute('aria-live', 'polite');
                  popup.innerHTML = `
                    <div class="header">
                      <div class="avatar">
                        <img src="${avatarSrc}" alt="user" />
                      </div>
                      <div style="flex:1;position:relative">
                        <div class="title">${newMsgTitle}</div>                        
                      </div>
                      <button class="close-x" aria-label="Dismiss">&times;</button>
                    </div>
                    <div class="body">${(function () {
                      const esc = (s) =>
                        String(s)
                          .replace(/&/g, '&amp;')
                          .replace(/</g, '&lt;')
                          .replace(/>/g, '&gt;');
                      return esc(botMsg);
                    })()}</div>
                    <div class="actions">
                      <button class="btn-dismiss add-button btn btn-secondary btn-xs">${dismissText}</button >
                    <button class="btn-open add-button btn btn btn-primary btn-xs">${openText}</button>
                    </div>
                    `;

                  // close/dismiss handlers
                  popup
                    .querySelector('.close-x')
                    .addEventListener('click', (e) => {
                      e.stopPropagation();
                      popup.remove();
                    });
                  popup
                    .querySelector('.btn-dismiss')
                    .addEventListener('click', (e) => {
                      e.stopPropagation();
                      popup.remove();
                    });

                  // open handler - navigate to agent-assist with incomingchatId
                  popup
                    .querySelector('.btn-open')
                    .addEventListener('click', (e) => {
                      e.stopPropagation();
                      try {
                        this.props.BotBlink(false);
                        this.props.AgentBlink(false);
                        this.props.history.push({
                          pathname: '/app/pages/agent-assist',
                          state: {
                            incomingPopChatId: message.ConversationId,
                            activeTab: 'Active',
                          },
                        });
                      } catch (err) {
                        window.location.href = '/app/pages/agent-assist';
                      }
                      popup.remove();
                    });

                  // clicking the body also opens conversation
                  popup.addEventListener('click', (e) => {
                    if (
                      e.target.closest('button') ||
                      e.target.classList.contains('close-x')
                    )
                      return;
                    try {
                      this.props.BotBlink(false);
                      this.props.AgentBlink(false);
                      this.props.history.push({
                        pathname: '/app/pages/agent-assist',
                        state: {
                          incomingPopChatId: message.ConversationId,
                          activeTab: 'Active',
                        },
                      });
                    } catch (err) {
                      window.location.href = '/app/pages/agent-assist';
                    }
                    popup.remove();
                  });

                  container.appendChild(popup);

                  // auto-remove after 10 seconds (adjust as wanted)
                  // const autoRemoveMs = 3600000;
                  // setTimeout(() => {
                  //   const el = document.getElementById(popupId);
                  //   if (el) el.remove();
                  // }, autoRemoveMs);
                } catch (err) {
                  console.error('Error showing styled chat popup:', err);
                }
              }
            }
          }

          if (message.Source === 'Visitor' && message.AgentId === getUserID()) {
            this.handleNotificationPopup(message.Content.messages[0]);
            this.audio.play();
            this.props.AgentBlink(true);
            // this.setState({ showAgentConversation: true });
            setTimeout(() => {
              this.setState({ showAgentConversation: false });
            }, 60000);
          }
        }
      );

      props.signalRConnection.newConnection.connection.on(
        'newChat',
        (message) => {
          this.audio.play();
          //this.setState({ showBotConversationOn: true });
          this.props.BotBlink(true);
          setTimeout(() => {
            this.setState({ showBotConversationOn: false });
          }, 60000);
        }
      );

      props.signalRConnection.newConnection.connection.on(
        'newAgentChat',
        (message) => {
          if (this.state.agentStatus) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_UpdateAgentStatus_By_Id}/${message}`,
              data: {
                groupId: getGroupID(),
                userId: getUserID(),
                status: 'RequestReceived',
              },
            });

            const checkConversations = this.state.chatInvitations.filter(
              (m) => m === message
            );
            if (checkConversations.length === 0) {
              this.handleNotificationPopup('New chat request arrived');
              this.setState({
                chatInvitations: [message, ...this.state.chatInvitations],
              });
              this.audio.play();
              this.props.AgentBlink(true);
              //this.setState({ showAgentConversation: true });
              setTimeout(() => {
                this.setState({ showAgentConversation: false });
              }, 60000);
            }
          }
        }
      );
    }

    // console.log(
    //   'props.signalRConnection.botBlink',
    //   props.signalRConnection.botBlink
    // );
    // console.log(
    //   'this.props.signalRConnection.botBlink',
    //   this.props.signalRConnection.botBlink
    // );
    if (
      (props.signalRConnection.newConnection !== undefined &&
        this.props.signalRConnection.newConnection === undefined &&
        props.signalRConnection.botBlink !== undefined &&
        this.props.signalRConnection.botBlink === undefined) ||
      (props.signalRConnection.newConnection !== undefined &&
        props.signalRConnection.botBlink !== undefined &&
        props.signalRConnection.botBlink !=
        this.props.signalRConnection.botBlink)
    ) {
      if (props.signalRConnection.botBlink === true) {
        this.setState({ showBotConversationOn: true });
      } else {
        this.setState({ showBotConversationOn: false });
      }
    }

    if (
      (props.signalRConnection.newConnection !== undefined &&
        this.props.signalRConnection.newConnection === undefined &&
        props.signalRConnection.agentBlink !== undefined &&
        this.props.signalRConnection.agentBlink === undefined) ||
      (props.signalRConnection.newConnection !== undefined &&
        props.signalRConnection.agentBlink !== undefined &&
        props.signalRConnection.agentBlink !=
        this.props.signalRConnection.agentBlink)
    ) {
      if (props.signalRConnection.agentBlink === true) {
        this.setState({ showAgentConversation: true });
      } else {
        this.setState({ showAgentConversation: false });
      }
    }
  }
  handleAivaRedirect = (groupId) => {
    this.setState({ loading: true });
    let AUTHORITY_SERVER = '';
    if (window.location.hostname.toLowerCase().includes('sabre'))
      AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('synxis'))
      AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
    else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    window.location.href = `${AUTHORITY_SERVER}/Aiva/AivaRedirection/${getUserID()}?groupId=${groupId}`;
  };
  acceptChat(id) {
    // console.log(id);
    var array = [...this.state.chatInvitations]; // make a separate copy of the array
    var index = array.indexOf(id);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ chatInvitations: array });
    }
    //this.props.history.push('/app/pages/conversations/active');
    this.props.BotBlink(false);
    this.props.AgentBlink(false);
    this.props.history.push({
      pathname: '/app/pages/agent-assist',
      state: { incomingchatId: id, activeTab: 'Active' }, // always open ActiveConversation tab
    });
  }
  componentDidMount() {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    }).then((res) => {
      if (
        res.data.logo !== undefined &&
        res.data.logo !== null &&
        res.data.logo !== ''
      ) {
        this.props.changeServiceProviderLogo(res.data.logo);
      }
      if (
        res.data.serviceProvider !== undefined &&
        res.data.serviceProvider !== null &&
        res.data.serviceProvider !== ''
      ) {
        this.props.changeServiceProvider(res.data.serviceProvider);
      }
      if (
        res.data.billingCurrency !== undefined &&
        res.data.billingCurrency !== null &&
        res.data.billingCurrency !== ''
      ) {
        this.props.changeGroupBillingCurrency(res.data.billingCurrency);
      }

      this.fetchColorTheme(res.data.serviceProvider);
    });

    this.setNotification();
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
    }).then((subscriptionResponse) => {
      if (
        subscriptionResponse.data.stripeCustomerId === null ||
        subscriptionResponse.data.stripeCustomerId === ''
      ) {
      } else {
        this.setState({
          stripeCustomerId: subscriptionResponse.data.stripeCustomerId,
        });
      }
    });
    // AxiosAPI({
    //   method: 'get',
    //   url: `${gAPI_Users_LinkedGrups_By_Id}?id=${getUserID()}&bmb=false&aiva=true`,
    // }).then((gresponse) => {
    //   // console.log(gresponse.data.filter((f) => f.id === getGroupID()));
    //   if (gresponse.data.filter((f) => f.groupId === getGroupID()).length == 0)
    //
    // });
    if (
      this.props.plist.filter((f) => f.isBmb === true).length === 0 &&
      this.props.plist.filter((f) => f.isAiva === true).length > 0
    ) {
      this.handleAivaRedirect(getGroupID());
    } else {
      if (
        this.props.plist.filter(
          (f) =>
            (f.isBmb === true || f.isVirtualFrontDesk === true) &&
            f.id === this.props.pid
        ).length !== 0 ||
        this.props.pid === '-1'
      )
        this.setHotelName(this.props.pid);
      else
        this.setHotelName(
          this.props.plist.filter(
            (f) => f.isBmb === true || f.isVirtualFrontDesk === true
          )[0].id
        );
    }

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_LinkedProperties_By_Id}?id=${getUserID()}&gid=${getGroupID()}&pid=${this.props.propertyId
        }&bmb=true&aiva=true`,
    }).then((response) => {
      if (response.data?.status && response.data.status === 'True')
        this.setState({ isAivaProperty: true });
    });

    AxiosAPI({
      method: 'get',
      url: `${gAPI_LinkedGrups_By_Id}/${getUserID()}`,
    }).then((response) => {
      this.setState({ linkedGroups: response.data });
      this.setState({ groupsList: response.data });
    });

    const user = this.props.userData;
    let agent = false;
    if (user !== undefined) {
      user.roles.forEach((r) => {
        if (r === 'Agent') {
          agent = true;
          this.setState({
            showAgentStatus: true,
            agentStatus: user.onlineStatus,
          });
          //Connect user to SignalR
          this.props.ConnectUser();
          this.props.fetchTwilioConversationsRequest();
        }
      });
    }
    //console.log('agent', agent);
    if (!agent) {
      this.props.SetAgent(false);
      //this.props.ConnectUser();
      //this.RefreshConversations();
      //setInterval(this.RefreshConversations, 60000);
    }
  }

  RefreshConversations = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_BotConversations_list}?gid=${getGroupID()}&pid=${this.props.pid
        }`,
    }).then((botresponse) => {
      // console.log(botresponse.data)
      if (botresponse.data.length > 0) {
        // console.log(this.state.botConversationList)
        // this.setState({ botConversationList: [...this.state.botConversationList, ...botresponse.data] })
        // this.setState({ showBotConversationOn: true })

        //if (this.state.showBotConversationOn === false) {
        this.audio.play();
        //}
        this.setState({ showBotConversationOn: true });
        setTimeout(() => {
          this.setState({ showBotConversationOn: false });
        }, 60000);
        botresponse.data.map((element, index) => {
          this.handleNotificationPopup(element.message);
        });
      } else {
        // this.setState({ showBotConversationOn: false })
      }
    });

    AxiosAPI({
      method: 'get',
      url: `${gAPI_AgentConversations_list}?gid=${getGroupID()}&pid=${this.props.pid
        }`,
    }).then((botresponse) => {
      //console.log(botresponse.data)
      this.setState({
        agentConversationList: [
          ...this.state.botConversationList,
          ...botresponse.data,
        ],
      });
      if (botresponse.data.length > 0) {
        // if (this.state.showAgentConversation === false) {
        this.audio.play();
        // }
        botresponse.data.map((element, index) => {
          this.handleNotificationPopup(element.message);
        });
        this.setState({ showAgentConversation: true });
        setTimeout(() => {
          this.setState({ showAgentConversation: false });
        }, 60000);
      } else {
        // this.setState({ showAgentConversation: false })
      }
    });
  };

  setHotelName = (id) => {
    //console.log(this.props.plist)
    const hotel = this.props.plist.find((elem) => {
      return elem.id === id;
    });
    //console.log(hotel);
    if (hotel) {
      // console.log(hotel);
      const name = hotel.name;
      const websiteLink = hotel.websiteLink;
      const rooms = hotel.rooms;
      const starRating = hotel.starRating;
      const type = hotel.type;
      const groupName = hotel.groupName;
      this.props.changeProperty(id);
      this.props.changeCurrency(hotel.currency);
      this.props.changeTimeZone(hotel.timeZone);
      this.setState({
        hotelName: name,
        websiteLink: websiteLink,
        rooms: rooms,
        starRating: starRating,
        type: type,
        groupName: groupName,
        activationdate: hotel.activationDate,
      });
    } else {
      console.log('not found');
      // this.props.changeProperty(this.state.propertyList[0].id);
      // this.setState({ hotelName: this.state.propertyList[0].name });
    }
  };

  handleChangeLocale = (locale, direction) => {
    this.props.changeLocale(locale);

    // const currentDirection = getDirection().direction;
    // if (direction !== currentDirection) {
    //   setDirection(direction);
    setTimeout(() => {
      window.location.reload();
    }, 500);
    //}
  };

  handleChangePropertyID = (propertyId, timeZone, currency) => {
    this.props.changeProperty(propertyId);
    this.props.changeTimeZone(timeZone);
    this.props.changeCurrency(currency);
    setTimeout(() => {
      let AUTHORITY_SERVER = '';
      if (window.location.hostname.toLowerCase().includes('sabre'))
        AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
      else if (window.location.hostname.toLowerCase().includes('synxis'))
        AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
      else if (window.location.hostname.toLowerCase().includes('myma.ai'))
        AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
      else if (
        window.location.hostname.toLowerCase().startsWith('smartpabx.ai')
      )
        AUTHORITY_SERVER = process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
      else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;

      window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${getGroupID()}&propertyId=${propertyId}`;
    }, 500);
  };
  handleChangeSelect = (e) => {
    this.setState({ loading: true });
    const groupId =
      e.value.split('|').length > 0 ? e.value.split('|')[0] : e.value;
    console.log('ee', e.value, groupId);
    let propertyId =
      e.value.split('|').length >= 1 ? e.value.split('|')[1] : '';
    let AUTHORITY_SERVER = '';
    if (window.location.hostname.toLowerCase().includes('sabre'))
      AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('synxis'))
      AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().startsWith('smartpabx.ai'))
      AUTHORITY_SERVER = process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
    else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${groupId}&propertyId=${propertyId}`;
  };
  handleChangePropertyIDAll = () => {
    this.props.changeProperty('-1');
    this.props.changeTimeZone('Etc/GMT');
    this.props.changeCurrency('');
    setTimeout(() => {
      let AUTHORITY_SERVER = '';
      if (window.location.hostname.toLowerCase().includes('sabre'))
        AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
      else if (window.location.hostname.toLowerCase().includes('synxis'))
        AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
      else if (window.location.hostname.toLowerCase().includes('myma.ai'))
        AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
      else if (
        window.location.hostname.toLowerCase().startsWith('smartpabx.ai')
      )
        AUTHORITY_SERVER = process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
      else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
      window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${getGroupID()}&propertyId=-1`;
    }, 500);
  };

  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };
  handleSearchIconClick = (e) => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains('search')) {
        if (e.target.parentElement.classList.contains('search')) {
          elem = e.target.parentElement;
        } else if (
          e.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = e.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
        this.removeEventsSearch();
      } else {
        elem.classList.add('mobile-view');
        this.addEventsSearch();
      }
    } else {
      this.search();
    }
  };
  addEventsSearch = () => {
    document.addEventListener('click', this.handleDocumentClickSearch, true);
  };
  removeEventsSearch = () => {
    document.removeEventListener('click', this.handleDocumentClickSearch, true);
  };

  handleDocumentClickSearch = (e) => {
    let isSearchClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains('navbar') ||
        e.target.classList.contains('simple-icon-magnifier'))
    ) {
      isSearchClick = true;
      if (e.target.classList.contains('simple-icon-magnifier')) {
        this.search();
      }
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      e.target.parentElement.classList.contains('search')
    ) {
      isSearchClick = true;
    }

    if (!isSearchClick) {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) input.classList.remove('mobile-view');
      this.removeEventsSearch();
      this.setState({
        searchKeyword: '',
      });
    }
  };
  handleSearchInputChange = (e) => {
    this.setState({
      searchKeyword: e.target.value,
    });
  };
  handleSearchInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  };

  handleAgentConversationClick = (e) => {
    // this.setState({ showAgentConversation: false });
    this.props.AgentBlink(false);
    // this.setState({
    //   showTwilioConversationList: true,
    // });
    this.props.history.push('/app/pages/agent-assist');
  };

  search = () => {
    this.props.history.push(searchPath + '/' + this.state.searchKeyword);
    this.setState({
      searchKeyword: '',
    });
  };

  toggleSwitchAccount = () => {
    this.setState({
      showLinkedGroups: !this.state.showLinkedGroups,
    });
  };

  toggleBussinessPopup = (e) => {
    e.preventDefault();
    // this.setState({
    //   bussinessProfileVisible: !this.state.bussinessProfileVisible,
    // });
    this.props.history.push('/app/pages/business-settings');
  };
  twilioStartChat = () => {
    this.setState({
      showTwilioConversationList: true,
    });
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen,
    });
  };

  handleChangePassword = () => {
    this.props.history.push('/app/pages/users/change-password');
  };

  handleSubscription = () => {
    this.props.history.push('/app/pages/billing/subscription');
  };

  handleLatestBotConversation = () => {
    //this.setState({ showBotConversationOn: false });
    this.props.BotBlink(false);
    this.props.history.push({
      pathname: '/app/pages/agent-assist',
      state: { from: 'NavBar' },
    });
  };

  handleInvoices = () => {
    this.StripeCustmerPortal(this.state.stripeCustomerId);
  };

  StripeCustmerPortal = (customerID) => {
    var qs = require('qs');
    var data = qs.stringify({
      customer: customerID,
      return_url: window.location.href,
    });
    AxiosAPI({
      method: 'post',
      url: `${postApi_Billing_Details}?url=v1/billing_portal/sessions`,
      data: data,
    })
      .then((stripeResponse) => {
        window.open(
          stripeResponse.data.url,
          '_blank' // <- This is what makes it open in a new window.
        );
      })
      .catch((err) => {
        AxiosAPI({
          method: 'post',
          url: `${postApi_Billing_Details_US}?url=v1/billing_portal/sessions`,
          data: data,
        }).then((stripeResponse) => {
          window.open(
            stripeResponse.data.url,
            '_blank' // <- This is what makes it open in a new window.
          );
        });
      });
  };

  handleLogout = (e) => {
    // this.props.logoutUser(this.props.history);
    e.preventDefault();
    let AUTHORITY_SERVER = '';
    if (window.location.hostname.toLowerCase().includes('sabre'))
      AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('synxis'))
      AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
    else if (window.location.hostname.toLowerCase().startsWith('smartpabx.ai'))
      AUTHORITY_SERVER = process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
    else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    let id_token = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
      )
    ).id_token;
    //this.props.history.push(`${AUTHORITY_SERVER}/Account/Logout?logoutId=${id_token}`)

    window.location.href = `${AUTHORITY_SERVER}/Account/Logout?logoutId=${id_token}`;
    // userManager.signoutRedirect();
    // userManager.removeUser();
  };

  handlePrivacy = (e) => {
    e.preventDefault();
    window.open('https://www.myma.ai/privacy-policy');
  };
  handleWebsiteLink = (e) => {
    e.preventDefault();
    window.open(this.state.websiteLink);
  };
  menuClickButton = (e) => {
    e.preventDefault();
    if (this.props.onMenuIconClick) {
      this.props.onMenuIconClick();
    }
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    setTimeout(() => {
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };
  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };
  fetchColorTheme = (serviceProvider) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Site_Settings}`,
    })
      .then((res) => {
        const matchedService = res.data.find(
          (item) => item.id.toString() === serviceProvider
        );
        if (matchedService) {
          this.setState({ helpcenterUrl: matchedService?.helpCenterUrl }); //set helpcenter url
          this.setState({ isShowChat: matchedService?.isShowChat }); //set show chatbot
          const color = matchedService.colorTheme || 'light.purple';
          localStorage.setItem(themeColorStorageKey, color);
        } else {
          localStorage.setItem(themeColorStorageKey, 'light.purple');
        }
      })
      .catch((err) => console.error('Error fetching color theme:', err));
  };
  setNotification = () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else if (Notification.permission === 'granted') {
      this.setState({ NotificationTitle: 'Notifications Allowed' });
    } else {
      this.setState({ NotificationTitle: 'Allow Notifications' });
    }
  };
  handleNotificationPopup = (msg) => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else if (Notification.permission === 'granted') {
      this.setState({ NotificationTitle: 'Notifications Allowed' });
      //var notification = new Notification(msg);
      var img =
        'https://bmbuiassetsprod.blob.core.windows.net/images/newlogo.png';
      var notification = new Notification('Myma.ai', {
        body: msg,
        icon: img,
      });
      notification.onclick = function (x) {
        window.focus();
        window.location.href = '/app/pages/agent-assist';
        this.close();
      };
      setTimeout(notification.close(), 1 * 1000);
    } else if (
      Notification.permission === 'denied' ||
      Notification.permission === 'default'
    ) {
      Notification.requestPermission(function (permission) {
        if (permission === 'granted') {
          var img =
            'https://bmbuiassetsprod.blob.core.windows.net/images/newlogo.png';
          var notification = new Notification('Myma.ai', {
            body: msg,
            icon: img,
          });
          notification.onclick = function (x) {
            window.focus();
            window.location.href = '/app/pages/agent-assist';
            this.close();
          };
          setTimeout(notification.close(), 1 * 1000);
        } else {
          Notification.requestPermission(function (per) {
            console.log(per);
          });
        }
      });
    }
  };
  handleAllowNotification = () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else {
      Notification.requestPermission().then((permission) => {
        console.log(permission);
        if (permission === 'granted') {
          this.setState({ NotificationTitle: 'Notifications Allowed' });
        }
      });
      console.log(Notification.permission);
      this.setState({ NotificationTitle: 'Allow Notifications' });
    }
  };
  handleSwitchChange = (value) => {
    console.log(value);
    AxiosAPI({
      method: 'put',
      url: `${putAPI_AgentStatus}/${getUserID()}/agent-status`,
      data: { status: value },
    }).then((subscriptionResponse) => {
      console.log('Status changed');
    });
    this.setState({ agentStatus: value });
  };
  rejectChat = (id) => {
    var array = [...this.state.chatInvitations]; // make a separate copy of the array
    var index = array.indexOf(id);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ chatInvitations: array });
    }
  };
  handleChangeProperty = (e) => {
    if (e.value === '-1') {
      this.handleChangePropertyIDAll();
    } else {
      var element = this.props.plist.filter((i) => i.id === e.value);
      this.handleChangePropertyID(
        element[0].id,
        element[0].timeZone,
        element[0].currency
      );
    }
  };
  onSearchKey = (e) => {
    var serachtext = e.target.value.toLowerCase();
    var resdata = this.props.plist.filter((a) =>
      a.name.toLowerCase().includes(serachtext)
    );
    this.setState({ propertyList: resdata });
  };
  handleHelpCenter = (e) => {
    e.preventDefault();
    window.open(
      this.state.helpcenterUrl !== null &&
        this.state.helpcenterUrl !== undefined
        ? this.state.helpcenterUrl
        : 'https://help.myma.ai/en/'
    );
  };
  render() {
    const {
      containerClassnames,
      menuClickCount,
      locale,
      user,
      usersListApp: { properties, isSuperAdmin },
      role,
      signalRConnection,
      serviceProvider,
      twilioConversationsReducer,
    } = this.props;

    const { messages } = this.props.intl;
    const group = getGroupID();
    var proList = this.props.plist
      ? [
        { id: '-1', name: 'All' },
        ...this.props.plist.filter((i) => i.isBmb === true),
      ].sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
      : [];
    proList = proList.sort((a, b) => a.name - b.name);
    // //Filter the localeOptions to only include English and Spanish
    // const filteredLocales = localeOptions.filter(
    //   (locale) => locale.id === 'en' || locale.id === 'es' || locale.id === 'hk' || locale.id === 'zh'
    // );

    return (
      <Fragment>
        <nav className="navbar fixed-top">
          <div className="d-flex align-items-center navbar-left">
            {serviceProvider &&
              serviceProvider !== '2' &&
              serviceProvider !== '5' ? (
              <NavLink
                to="#"
                className="menu-button d-none d-md-block"
                onClick={(e) => this.menuClickButton(e)}
              >
                <MenuIcon />
              </NavLink>
            ) : (
              <NavLink
                to="#"
                className="menu-button d-none d-md-block"
                onClick={(e) =>
                  this.menuButtonClick(e, menuClickCount, containerClassnames)
                }
              >
                <MenuIcon />
              </NavLink>
            )}
            <NavLink
              to="#"
              className="menu-button-mobile d-xs-block d-sm-block d-md-none"
              onClick={(e) =>
                this.mobileMenuButtonClick(e, containerClassnames)
              }
            >
              <MobileMenuIcon />
            </NavLink>

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="sm"
                  className="language-button"
                >
                  <span className="name">
                    <b>
                      {this.state.hotelName === 'All'
                        ? 'Group Info'
                        : this.state.hotelName}
                    </b>
                  </span>
                </DropdownToggle>
                <DropdownMenu
                  style={{ maxHeight: '400px', overflowY: 'auto' }}
                  className="mt-3"
                  right
                >
                  <div className="search-property">
                    <input
                      type="text"
                      placeholder="Search"
                      onKeyUp={(e) => this.onSearchKey(e)}
                    ></input>
                  </div>
                  {this.props.plist && this.props.plist.length > 0 && (
                    <DropdownItem
                      onClick={() => this.handleChangePropertyIDAll()}
                    >
                      Group Info
                    </DropdownItem>
                  )}
                  {this.props.plist
                    ? this.state.propertyList
                      .sort(function (a, b) {
                        if (a.name < b.name) {
                          return -1;
                        }
                        if (a.name > b.name) {
                          return 1;
                        }
                        return 0;
                      })
                      .sort((a, b) => a.name - b.name)
                      .map((element, index) => {
                        if (
                          element.isBmb === true ||
                          element.isVirtualFrontDesk === true
                        ) {
                          return (
                            <DropdownItem
                              onClick={() =>
                                this.handleChangePropertyID(
                                  element.id,
                                  element.timeZone,
                                  element.currency
                                )
                              }
                              key={index}
                            >
                              {element.name}
                            </DropdownItem>
                          );
                        }
                      })
                    : []}
                </DropdownMenu>
                {/* <DropdownMenu className="mt-3" right>
                {properties
                  ? reactSelectOption(properties, true).map(
                      (element, index) => {
                        return (
                          <DropdownItem
                            onClick={() =>
                              this.handleChangeLocale(
                                element.value,
                                element.label
                              )
                            }
                            key={index}
                          >
                            {element.label}
                          </DropdownItem>
                        );
                      }
                    )
                  : []}
              </DropdownMenu> */}
              </UncontrolledDropdown>
            </div>

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="xs"
                  className="language-option"
                >
                  <span className="name">{locale.toUpperCase()}</span>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right>
                  {localeOptions.map((elem, index) => {
                    return (
                      <DropdownItem
                        onClick={() =>
                          this.handleChangeLocale(elem.id, elem.direction)
                        }
                        key={index}
                      >
                        {elem?.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
          <a className="navbar-logo" href="/">
            {
              this.props.serviceProviderLogo !== undefined &&
              this.props.serviceProviderLogo != null &&
              this.props.serviceProviderLogo !== '' && (
                <img
                  src={this.props.serviceProviderLogo}
                  width={1168 / 9}
                  height={158 / 2}
                  alt="logo"
                />
              )
              // :
              // <img src={logo} width={1168 / 9} height={158 / 2} alt="logo" />
            }
          </a>
          <div className="navbar-right">
            {/* {themeColorStorageKey && < ColorSwitcher />}  */}
            <div className="header-icons d-inline-block align-middle">
              {this.state.isAivaProperty !== undefined &&
                this.state.isAivaProperty == true && (
                  <TopnavEasyAccess
                    handleAivaRedirect={this.handleAivaRedirect}
                  />
                )}

              {/* <TopnavEasyAccess /> */}
              {/* <TopnavNotifications /> */}
              {this.state.showAgentStatus === false && (
                <Fragment>
                  {/* {this.state.showBotConversationOn === true && (
                    <a
                      onClick={this.handleLatestBotConversation}
                      className="header-icon  d-sm-inline-block"
                      title="Active Conversations"
                    >
                      <img
                        src="/assets/img/bot-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )} */}

                  {/* {this.state.showBotConversationOn === false && ( */}
                  <a
                    //onClick={this.handleLatestBotConversation}
                    href="#"
                    className="header-icon  d-sm-inline-block"
                    title="You need agent role to take over the conversations or to accept customer initiated Live Chat requests. Contact your Administrator."
                  >
                    <img src="/assets/img/bot-off.png" width={25} height={25} />{' '}
                  </a>
                  {/* )} */}

                  {/* {this.state.showAgentConversation === true && (
                    <a
                      onClick={this.handleAgentConversationClick}
                      className="header-icon  d-sm-inline-block"
                      title="Agent Conversations"
                    >
                      <img
                        src="/assets/img/agent-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )} */}

                  {/* {this.state.showAgentConversation === false && ( */}
                  <a
                    //onClick={this.handleAgentConversationClick}
                    href="#"
                    className="header-icon  d-sm-inline-block"
                    title="You need agent role to take over the conversations or to accept customer initiated Live Chat requests. Contact your Administrator."
                  >
                    <img
                      src="/assets/img/agent-off.png"
                      width={25}
                      height={25}
                    />{' '}
                  </a>
                  {/* )} */}
                </Fragment>
              )}

              {this.state.showAgentStatus && (
                <Fragment>
                  {this.state.showBotConversationOn === true && (
                    <a
                      onClick={this.handleLatestBotConversation}
                      className="header-icon d-sm-inline-block"
                      title="Active Conversations"
                    >
                      <img
                        src="/assets/img/bot-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )}

                  {this.state.showBotConversationOn === false && (
                    <a
                      onClick={this.handleLatestBotConversation}
                      className="header-icon d-sm-inline-block"
                      title="Active Conversations"
                    >
                      <img
                        src="/assets/img/bot-off.png"
                        width={25}
                        height={25}
                      />{' '}
                    </a>
                  )}

                  {this.state.showAgentConversation === true && (
                    <a
                      onClick={this.handleAgentConversationClick}
                      className="header-icon d-sm-inline-block"
                      title="Agent Conversations"
                    >
                      <img
                        src="/assets/img/agent-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )}

                  {this.state.showAgentConversation === false && (
                    <a
                      onClick={this.handleAgentConversationClick}
                      className="header-icon d-sm-inline-block"
                      title="Agent Conversations"
                    >
                      <img
                        src="/assets/img/agent-off.png"
                        width={25}
                        height={25}
                      />{' '}
                    </a>
                  )}
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-3 d-sm-inline-block"
                    checked={this.state.agentStatus}
                    onChange={(primary) => this.handleSwitchChange(primary)}
                  />
                  {this.state.agentStatus ? (
                    <span
                      className="ml-2 align-bottom"
                      style={{ fontSize: '0.8rem' }}
                    >
                      <IntlMessages id="dashboards.online" />{' '}
                    </span>
                  ) : (
                    <span
                      className="ml-2 align-bottom"
                      style={{ fontSize: '0.8rem' }}
                    >
                      <IntlMessages id="dashboards.offline" />{' '}
                    </span>
                  )}
                </Fragment>
              )}
            </div>

            <div className="user d-inline-block">
              <UncontrolledDropdown className="dropdown-menu-right">
                <DropdownToggle className="p-0" color="empty">
                  <span className="name mr-1">{user && user.profile.name}</span>
                  <button
                    className="header-icon btn btn-empty d-none d-sm-inline-block"
                    id="fullScreenButton"
                    onClick={this.toggleFullScreen}
                  >
                    {this.state.isInFullScreen ? (
                      <i className="simple-icon-size-actual d-block" />
                    ) : (
                      <i className="simple-icon-size-fullscreen d-block" />
                    )}
                  </button>
                  <button
                    className="header-icon btn btn-empty d-none d-sm-inline-block"
                    type="button"
                  >
                    <i
                      className="d-block simple-icon-settings"
                      id="nametip"
                    ></i>
                  </button>
                  <button
                    className="header-icon btn btn-empty d-sm-inline-block help-icon"
                    id="helpHand"
                    onClick={(e) => this.handleHelpCenter(e)}
                  >
                    {' '}
                    ?
                  </button>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right>
                  {/* <DropdownItem>Account</DropdownItem>
                <DropdownItem>Features</DropdownItem>
                <DropdownItem>History</DropdownItem> */}
                  <DropdownItem>
                    <div className="user-info">
                      <div className="row">
                        <div className="col-md-2">
                          <div className="round-name">
                            <span>
                              <b>
                                {user &&
                                  user?.profile?.name &&
                                  user?.profile?.name != null && (
                                    <Fragment>
                                      {user.profile.name.split(' ').length > 1
                                        ? user.profile.name.split(' ')[0][0] +
                                        user.profile.name.split(' ')[1][0]
                                        : user.profile.name[0] +
                                        user.profile.name[1]}
                                    </Fragment>
                                  )}
                              </b>
                            </span>
                          </div>
                        </div>
                        <div className="col-md-9 hello-nav">
                          <p>
                            <IntlMessages id="dashboards.hello" />,
                          </p>
                          <h6>
                            <b>{user && user.profile.name}</b>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.handleChangePassword(e)}>
                    {' '}
                    <IntlMessages id="dashboards.change-password" />
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.handleLogout(e)}>
                    <IntlMessages id="dashboards.sign-out" />
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={(e) => this.handlePrivacy(e)}>
                    <IntlMessages id="dashboards.privacy-policy" />
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.handleHelpCenter(e)}>
                    <IntlMessages id="dashboards.help-center" />
                  </DropdownItem>
                  {this.state.linkedGroups.length > 1 && (
                    <Fragment>
                      {' '}
                      <DropdownItem divider />
                      <DropdownItem onClick={(e) => this.toggleSwitchAccount()}>
                        <IntlMessages id="dashboards.switch-account" />
                      </DropdownItem>
                    </Fragment>
                  )}
                  {this.props.propertyId !== '-1' &&
                    (getUserRole() === 'Admin' ||
                      getUserRole() === 'SuperAdmin') && (
                      <Fragment>
                        <DropdownItem divider />
                        <DropdownItem
                          onClick={(e) => this.toggleBussinessPopup(e)}
                        >
                          {' '}
                          <IntlMessages id="dashboards.business-settings" />
                        </DropdownItem>
                      </Fragment>
                    )}
                  {this.state.stripeCustomerId !== '' &&
                    (getUserRole() === 'Admin' ||
                      getUserRole() === 'SuperAdmin') && (
                      <Fragment>
                        <DropdownItem onClick={(e) => this.handleInvoices(e)}>
                          {' '}
                          <IntlMessages id="dashboards.invoice-&-payments" />
                        </DropdownItem>
                        <DropdownItem
                          onClick={(e) => this.handleSubscription(e)}
                        >
                          {' '}
                          <IntlMessages id="dashboards.upgrade-plan" />
                        </DropdownItem>
                      </Fragment>
                    )}

                  {/* {this.state.NotificationTitle !== '' && ( */}
                  <Fragment>
                    <DropdownItem divider />
                    <DropdownItem
                      className="pb-2"
                      onClick={(e) => this.handleAllowNotification(e)}
                    >
                      {this.state.NotificationTitle ===
                        'Notifications Allowed' ? (
                        <IntlMessages id="dashboards.notificationsAllowed" />
                      ) : this.state.NotificationTitle ===
                        'Allow Notifications' ? (
                        <IntlMessages id="dashboards.allowNotifications" />
                      ) : (
                        this.state.NotificationTitle
                      )}
                    </DropdownItem>
                  </Fragment>
                  <Fragment>
                    {isDarkSwitchActive && <TopnavDarkSwitch />}
                  </Fragment>
                  {/* )} */}
                  <DropdownItem divider />
                  <span className="dropdown-item pb-0 pt-0">
                    {/* {this.state.hotelName} */}
                    {this.state.hotelName === 'All'
                      ? 'Group Info'
                      : this.state.hotelName}
                  </span>
                  <span className="dropdown-item pb-0 pt-0">
                    Type : {this.state.type}
                  </span>
                  <span className="dropdown-item pb-0 pt-0">
                    <a
                      onClick={(e) => this.handleWebsiteLink(e)}
                      className="btn-link"
                      style={{ textDecoration: 'underline' }}
                    >
                      {this.state.websiteLink}
                    </a>
                  </span>
                  <span
                    className="dropdown-item pb-0 pt-0"
                    style={{ display: this.state.rooms > 0 ? 'block' : 'none' }}
                  >
                    Rooms : {this.state.rooms}
                  </span>
                  <span
                    className="dropdown-item pb-0 pt-0"
                    style={{
                      display: this.state.starRating > 0 ? 'block' : 'none',
                    }}
                  >
                    Star Rating : {this.state.starRating}
                  </span>
                  <span className="dropdown-item pt-0">
                    Group : {this.state.groupName}
                  </span>

                  {this.state.activationdate !== undefined &&
                    this.state.activationdate !== null &&
                    moment(this.state.activationdate).format('MMM DD, YYYY') !==
                    'Jan 01, 0001' && (
                      <span className="dropdown-item pt-0">
                        Activated :{' '}
                        {moment(this.state.activationdate).format(
                          'MMM DD, YYYY'
                        )}
                      </span>
                    )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </nav>

        <Modal
          isOpen={this.state.showLinkedGroups}
          keyboard="false"
          backdrop="static"
          toggle={this.toggleSwitchAccount}
        >
          <ModalHeader>Choose the Group to Switch</ModalHeader>
          <ModalBody>
            {this.state.loading ? (
              <div>
                {/* <Spinner color="primary" className="mb-1" /> */}
                <div className="text-center loading" />
                <p>Your request is in progress</p>
              </div>
            ) : (
              <Select
                isMulti={false}
                className="react-select"
                classNamePrefix="react-select"
                name="id"
                placeholder="Select Group or Property"
                onChange={(e) => this.handleChangeSelect(e)}
                options={
                  this.state.linkedGroups
                    ? reactSelectProperties(
                      this.state.linkedGroups,
                      true,
                      'id',
                      'name',
                      'propertyId'
                    )
                    : []
                }
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleSwitchAccount}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {this.state.chatInvitations.length > 0 && (
          <Fragment>
            <div className="ongoing">
              <ul style={{ float: 'right' }}>
                {this.state.chatInvitations.map((person, i) => (
                  <div className="msg_box" style={{ right: `${270 * i}px` }}>
                    <div className="msg_head">
                      <div
                        className="chatclose"
                        onClick={() => this.rejectChat(person)}
                      >
                        x
                      </div>
                    </div>
                    <div className="msg_wrap">
                      <div className="msg_body">
                        <p>
                          User requested to chat with an agent. Open queue to
                          view and accept the chat.{' '}
                        </p>
                        <p>
                          <Button
                            color="primary"
                            outline
                            size="xs"
                            onClick={() => this.acceptChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Go to Queue
                          </Button>{' '}
                          <Button
                            color="secondary"
                            outline
                            size="xs"
                            onClick={() => this.rejectChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Cancel
                          </Button>{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          </Fragment>
        )}
        {this.state.isShowChat !== null &&
          this.state.isShowChat !== undefined &&
          this.state.isShowChat === true && <Intercom></Intercom>}
        <BusinessProfile
          visible={this.state.bussinessProfileVisible}
          toggle={() => {
            this.setState({ bussinessProfileVisible: false });
          }}
          propertyId={this.props.propertyId}
          groupId={getGroupID()}
        ></BusinessProfile>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  menu,
  settings,
  oidc,
  usersListApp,
  signalRConnection,
  twilioConversationsReducer,
}) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale, propertyId, serviceProviderLogo } = settings;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    propertyId,
    user: oidc.user,
    usersListApp,
    signalRConnection,
    serviceProviderLogo,
    twilioConversationsReducer,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
    logoutUser,
    changeLocale,
    changeProperty,
    changeTimeZone,
    changeCurrency,
    changeGroupBillingCurrency,
    getPropertyList,
    ConnectUser,
    SetAgent,
    BotBlink,
    AgentBlink,
    changeServiceProvider,
    changeServiceProviderLogo,
    fetchTwilioConversationsRequest,
  })(TopNav)
);
